import React from 'react';
import { toast } from 'react-toastify';
import Toast from 'components/Toast';
import { TOASTS_VARIANTS, TOASTS_TEMPLATES } from 'constants/toastTypes';

const Notify = {};

const delay = {
  normalDelay: 4000,
  slowDelay: 6000,
};

Notify.success = (props = {}) => {
  if (props.template === TOASTS_TEMPLATES.PRELOADER) {
    return toast.success(<Toast {...props} />, {
      autoClose: false,
      closeButton: false,
      closeOnClick: false,
      hideProgressBar: true,
    });
  }

  return toast.success(<Toast {...props} />, {
    autoClose: delay.normalDelay,
    hideProgressBar: true,
  });
};

Notify.warning = (props = {}) =>
  toast.warning(<Toast variant={TOASTS_VARIANTS.WARNING} {...props} />, {
    autoClose: delay.normalDelay,
    hideProgressBar: true,
  });

Notify.error = (props = {}) =>
  toast.error(<Toast variant={TOASTS_VARIANTS.ERROR} {...props} />, {
    autoClose: delay.slowDelay,
    hideProgressBar: true,
  });

export default Notify;
